<template>
    <InputDateTime
        v-bind="{ ...props }"
        @update:model-value="handleModelUpdate"
        @submit="emit('submit')"
    />
</template>

<script setup>
import InputDateTime from '../InputDateTime/InputDateTime.vue'

defineOptions({ inheritAttrs: false })

const props = defineProps({
    id: String,
    modelValue: String,
    format: {
        type: String,
        default: 'YYYY-MM-DD',
    },
    label: String,
    disabled: Boolean,
    disableWeekends: Boolean,
    min: String,
    max: String,
    initialValue: String,
    error: [String, Boolean],
    applyLabel: {
        type: String,
        default: '',
    },
    blockPath: Array,
    customCssVariables: Object,
})

const emit = defineEmits(['update:modelValue', 'submit'])

const handleModelUpdate = (value) => {
    emit('update:modelValue', value)
}
</script>
